import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CrudService } from 'src/app/@amiga-pyme/services/crud.service';

const baseRoute = '/active-ingredients';

@Injectable({
  providedIn: 'root'
})
export class ActiveIngredientService extends CrudService {
  constructor(http: HttpClient) {
    super(http, baseRoute);
  }
}
